<div class="container" *ngIf="url">
    <div class="row justify-content-center">
        <iframe [src]="url | safe" width="100%" style="height: 80vh"></iframe>
    </div>
    <a href="{{ url }}" target="_blank">Click to open link in new tab</a>
</div>
